import React from 'react';
import Link from './simpleComponents/Link';
import { observer } from 'mobx-react';
const CMSLink = observer(props => {
  return /*#__PURE__*/React.createElement(Link, props);
});
export default CMSLink;